"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NO_RESPONSE_STATUS_CODE = exports.ExtendedAxiosError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
/**
 * Represents a status code of `0` to indicate that no response was received from the server.
 *
 * @remarks
 * This constant is used in scenarios where the HTTP request did not reach the server or the server
 * did not provide a valid response, such as when the network is unavailable, the request times out,
 * or there's a CORS error. Since `0` is not a valid HTTP status code, it serves as a special
 * placeholder to signal the absence of any server response.
 */ var NO_RESPONSE_STATUS_CODE = exports.NO_RESPONSE_STATUS_CODE = 0;
/**
 * This formats AxiosError into more readable object not only for user but also for Application Insights
 */ var ExtendedAxiosError = /*#__PURE__*/ function(Error1) {
    _inherits(ExtendedAxiosError, Error1);
    function ExtendedAxiosError(axiosError) {
        _class_call_check(this, ExtendedAxiosError);
        var _this;
        var _this1;
        _this = _call_super(this, ExtendedAxiosError, [
            axiosError.message.startsWith('Axios Error: ') ? axiosError.message : "Axios Error: ".concat(axiosError.message)
        ]);
        (0, _defineProperty2.default)(_this, "baseUrl", void 0);
        (0, _defineProperty2.default)(_this, "pathname", void 0);
        (0, _defineProperty2.default)(_this, "method", void 0);
        (0, _defineProperty2.default)(_this, "statusCode", void 0);
        (0, _defineProperty2.default)(_this, "statusText", void 0);
        (0, _defineProperty2.default)(_this, "responseBody", null);
        (0, _defineProperty2.default)(_this, "callstack", void 0);
        _this.name = 'ExtendedAxiosError';
        var response = axiosError.response, stack = axiosError.stack, code = axiosError.code, config = axiosError.config, status = axiosError.status;
        var _response_config_baseURL, _ref;
        // Response could be undefined on timeout for example
        _this.baseUrl = (_ref = (_response_config_baseURL = response === null || response === void 0 ? void 0 : response.config.baseURL) !== null && _response_config_baseURL !== void 0 ? _response_config_baseURL : config === null || config === void 0 ? void 0 : config.baseURL) !== null && _ref !== void 0 ? _ref : null;
        var _response_config_url, _ref1;
        _this.pathname = (_ref1 = (_response_config_url = response === null || response === void 0 ? void 0 : response.config.url) !== null && _response_config_url !== void 0 ? _response_config_url : config === null || config === void 0 ? void 0 : config.url) !== null && _ref1 !== void 0 ? _ref1 : null;
        var _response_config_method, _toUpperCase;
        _this.method = (_toUpperCase = (_this1 = (_response_config_method = response === null || response === void 0 ? void 0 : response.config.method) !== null && _response_config_method !== void 0 ? _response_config_method : config === null || config === void 0 ? void 0 : config.method) === null || _this1 === void 0 ? void 0 : _this1.toUpperCase()) !== null && _toUpperCase !== void 0 ? _toUpperCase : null;
        var _response_status, _ref2;
        _this.statusCode = (_ref2 = (_response_status = response === null || response === void 0 ? void 0 : response.status) !== null && _response_status !== void 0 ? _response_status : status) !== null && _ref2 !== void 0 ? _ref2 : NO_RESPONSE_STATUS_CODE;
        var _response_statusText, _ref3;
        _this.statusText = (_ref3 = (_response_statusText = response === null || response === void 0 ? void 0 : response.statusText) !== null && _response_statusText !== void 0 ? _response_statusText : code) !== null && _ref3 !== void 0 ? _ref3 : null;
        // No need to pass body on 404 and empty body
        if (_this.statusCode !== 404 && (response === null || response === void 0 ? void 0 : response.data) != null) {
            _this.responseBody = response.data;
        }
        _this.callstack = stack !== null && stack !== void 0 ? stack : null;
        return _this;
    }
    return ExtendedAxiosError;
}(_wrap_native_super(Error));
exports.ExtendedAxiosError = ExtendedAxiosError; //# sourceMappingURL=ExtendedAxiosError.js.map
